<template>
  <div class="paper-preview">
    <PaperInfo :info="paperResourceInfo" />
    <div class="preview-container">
      <div class="preview-container-content">
        <div class="preview-picture-container">
          <div class="preview-picture-list" v-if="previewPictureList.length">
            <img
              v-for="(item, index) in previewPictureList"
              :key="index"
              :src="item.data"
              loading="lazy"
              alt=""
            />
          </div>
          <div class="empty-picture-container" v-else>
            <NoContent type="1" message="暂无法预览，请稍后再来" />
          </div>
        </div>
        <paper-download-button
          v-if="previewPictureList.length"
          :is-pop-with-dialog="false"
          @download="handleDownload"
        />
      </div>
    </div>
  </div>
</template>
<script>
import PaperInfo from "./components/PaperInfo.vue";
import PaperDownloadButton from "./components/PaperDownloadButton.vue";
import api from "@/assets/js/service/api";
import request from "@/utils/request";
import softUtil from "@/assets/js/service/softUtil";
import NoContent from "@/components/NoContent.vue";
export default {
  name: "PaperPreview",
  components: {
    PaperInfo,
    PaperDownloadButton,
    NoContent,
  },
  mixins: [],
  props: {},
  data() {
    return {
      paperResourceInfo: {},
      previewPictureList: [],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.loadPaperInfo();
    this.getPreviewPictureList();
  },
  methods: {
    async loadPaperInfo() {
      const { paperId } = this.$route.params;
      const res = await request.get(api.paper.resourceInfo, {
        resourceId: paperId,
      });
      this.paperResourceInfo = res.result;
    },
    async getPreviewPictureList() {
      const { paperId } = this.$route.params;
      const res = await request.get(api.paper.reviewUrls, {
        paperId,
      });
      if (
        res.result &&
        res.result.previewFileList &&
        res.result.previewFileList.length
      ) {
        this.previewPictureList = res.result.previewFileList[0].contentList;
      }
    },
    handleDownload() {
      softUtil.downloadPaper({
        paperId: +this.$route.params.paperId,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.paper-preview {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .preview-container {
    flex: 1;
    background: #eaeff2;
    border-radius: 8px 8px 0 0;
    padding: 20px;
    overflow: hidden;

    .preview-container-content {
      height: 100%;
      position: relative;
    }

    &:has(.paper-bottom-download) {
      .preview-picture-container {
        padding-bottom: 66px;
      }
    }
    .preview-picture-container {
      height: 100%;
      overflow: scroll;
      background: #fff;
      .preview-picture-list {
        background: #fff;
        border-radius: 8px;
        overflow-y: scroll;
      }
      .empty-picture-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
    }
  }
}
</style>
